import { render, staticRenderFns } from "./employeesSalarie.vue?vue&type=template&id=920d54fe"
import script from "./employeesSalarie.vue?vue&type=script&lang=js"
export * from "./employeesSalarie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports